import React from 'react';
import I18N from '@leverege/i18n';
import GeoPointDistanceComparatorEditor from "./GeoPointDistanceComparatorEditor.js";
import GeoPointFartherThanComparator from './GeoPointFartherThanComparator.js';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t
} = I18N.ns('ui-attributes.condition.comparator.type.geoPoint.GeoPointFartherThanComparatorEditor');
export default function GeoPointFartherThanComparatorEditor(props) {
  const {
    variant
  } = props;
  return /*#__PURE__*/_jsx(GeoPointDistanceComparatorEditor, {
    Model: GeoPointFartherThanComparator,
    toggleVariant: variant,
    ...props
  });
}
GeoPointFartherThanComparatorEditor.isInline = true;
GeoPointFartherThanComparatorEditor.TYPE = GeoPointFartherThanComparator.TYPE;
GeoPointFartherThanComparatorEditor.getSelectedName = value => {
  return t('selectedName');
};